import React, { useEffect, useRef, useState } from 'react'
import { completeSSOLogin } from '@assembly/api/auth'
import { RoutePaths } from '@assembly/constants'
import { Box, Button, CircularProgress, Typography } from '@mui/material'

const redirectUri = () => `${window.location.origin}${RoutePaths.MainSSOCallback}`

export default function MainSSOCallback() {
  const [error, setError] = useState<string | null>(null)
  const completedRef = useRef(false)

  useEffect(() => {
    if (completedRef.current) return

    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')

    if (params.get('error')) {
      completedRef.current = true
      setError(params.get('error_description') || params.get('error') || 'Authentication failed')
      return
    }
    if (!code || !state) {
      completedRef.current = true
      setError('Missing code or state')
      return
    }

    completedRef.current = true

    const run = async () => {
      try {
        await completeSSOLogin({ code, state, redirectUri: redirectUri() })
        window.location.href = '/'
      } catch (e: any) {
        const msg = e?.response?.data?.message || e?.message || 'Sign-in failed'
        if (msg.includes('Invalid or expired state')) {
          window.location.href = '/'
          return
        }
        setError(msg)
      }
    }
    run()
  }, [])

  if (error) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" p={4} gap={3}>
        <Typography color="error" sx={{ textAlign: 'center', maxWidth: 360 }}>
          {error}
        </Typography>
        <Button href={RoutePaths.Root} variant="contained" sx={{ mt: 1 }}>
          Return to login
        </Button>
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={3}>
      <CircularProgress />
      <Typography>Completing sign-in...</Typography>
    </Box>
  )
}
